import { type EngagementHorizontalData, type EngagementLineData } from "features/Library/Pdfs/types/state";
import {
  type EmailCounts,
  type EngagementCounts,
  type EmailDetails,
  type FlowCards,
  type FlowDetails,
  type AssetActivityCounts,
  type VideoActivityCounts,
  type VideoDetails,
  type AssessmentActivityCounts,
  type AssessmentEngagement,
  type AssessmentDetails,
  type SurveyActivityCounts,
  type SurveyEngagement,
  type SurveyDetails,
  type PdfDetails,
  type VideoEngagement,
  type PhishingCampaignEngagementData,
  type PhishingCampaignLineData,
  type PhishingCampaignChartData,
  type PhishingCampaignDetails,
  type LinkCounts,
  type LinkEngagementCounts,
  type LinkOverviewDetails,
  type LinkUserDetails,
  type MessageOverviewDetails,
} from "../types/content";
import { type MessageEngagement, type MessageLineChart } from "features/Library/Communications/Messages/types/models";
import { type CardReportingItem } from "components/cards/CardReporting/CardReporting";
import { completes, starts } from "features/Library/Common/utils/performanceUtils";
import { reportingColors } from "features/Library/Common/utils/constants";
import { type DataPoint } from "components/charts/types/HorizontalBarChart";
import { type EventsTableEntity } from "../Content/sections/Events/EventsReport";
import { AssetTypes } from "enums";

export const mockEmailDensity: EmailCounts[] = [
  {
    Date: "2023-07-12",
    Clicks: 3,
    Opens: 26,
    Sends: 65,
    CumulativeClicks: 3,
    CumulativeOpens: 26,
    CumulativeSends: 65,
  },
  {
    Date: "2023-07-13",
    Clicks: 91,
    Opens: 61,
    Sends: 38,
    CumulativeClicks: 94,
    CumulativeOpens: 87,
    CumulativeSends: 103,
  },
  {
    Date: "2023-07-14",
    Clicks: 34,
    Opens: 51,
    Sends: 67,
    CumulativeClicks: 128,
    CumulativeOpens: 138,
    CumulativeSends: 170,
  },
  {
    Date: "2023-07-15",
    Clicks: 67,
    Opens: 52,
    Sends: 34,
    CumulativeClicks: 195,
    CumulativeOpens: 190,
    CumulativeSends: 204,
  },
  {
    Date: "2023-07-16",
    Clicks: 18,
    Opens: 3,
    Sends: 97,
    CumulativeClicks: 213,
    CumulativeOpens: 193,
    CumulativeSends: 301,
  },
  {
    Date: "2023-07-17",
    Clicks: 58,
    Opens: 4,
    Sends: 78,
    CumulativeClicks: 271,
    CumulativeOpens: 197,
    CumulativeSends: 379,
  },
  {
    Date: "2023-07-18",
    Clicks: 21,
    Opens: 22,
    Sends: 38,
    CumulativeClicks: 292,
    CumulativeOpens: 219,
    CumulativeSends: 417,
  },
  {
    Date: "2023-07-19",
    Clicks: 56,
    Opens: 44,
    Sends: 99,
    CumulativeClicks: 348,
    CumulativeOpens: 263,
    CumulativeSends: 516,
  },
  {
    Date: "2023-07-20",
    Clicks: 22,
    Opens: 21,
    Sends: 89,
    CumulativeClicks: 370,
    CumulativeOpens: 284,
    CumulativeSends: 605,
  },
  {
    Date: "2023-07-21",
    Clicks: 74,
    Opens: 80,
    Sends: 94,
    CumulativeClicks: 444,
    CumulativeOpens: 364,
    CumulativeSends: 699,
  },
  {
    Date: "2023-07-22",
    Clicks: 73,
    Opens: 20,
    Sends: 24,
    CumulativeClicks: 517,
    CumulativeOpens: 384,
    CumulativeSends: 723,
  },
  {
    Date: "2023-07-23",
    Clicks: 47,
    Opens: 20,
    Sends: 38,
    CumulativeClicks: 564,
    CumulativeOpens: 404,
    CumulativeSends: 761,
  },
  {
    Date: "2023-07-24",
    Clicks: 38,
    Opens: 58,
    Sends: 67,
    CumulativeClicks: 602,
    CumulativeOpens: 462,
    CumulativeSends: 828,
  },
  {
    Date: "2023-07-25",
    Clicks: 48,
    Opens: 30,
    Sends: 52,
    CumulativeClicks: 650,
    CumulativeOpens: 492,
    CumulativeSends: 880,
  },
  {
    Date: "2023-07-26",
    Clicks: 32,
    Opens: 76,
    Sends: 88,
    CumulativeClicks: 682,
    CumulativeOpens: 568,
    CumulativeSends: 968,
  },
  {
    Date: "2023-07-27",
    Clicks: 67,
    Opens: 75,
    Sends: 35,
    CumulativeClicks: 749,
    CumulativeOpens: 643,
    CumulativeSends: 1003,
  },
  {
    Date: "2023-07-28",
    Clicks: 15,
    Opens: 88,
    Sends: 14,
    CumulativeClicks: 764,
    CumulativeOpens: 731,
    CumulativeSends: 1017,
  },
  {
    Date: "2023-07-29",
    Clicks: 40,
    Opens: 20,
    Sends: 35,
    CumulativeClicks: 804,
    CumulativeOpens: 751,
    CumulativeSends: 1052,
  },
  {
    Date: "2023-07-30",
    Clicks: 45,
    Opens: 38,
    Sends: 8,
    CumulativeClicks: 849,
    CumulativeOpens: 789,
    CumulativeSends: 1060,
  },
  {
    Date: "2023-07-31",
    Clicks: 96,
    Opens: 68,
    Sends: 61,
    CumulativeClicks: 945,
    CumulativeOpens: 857,
    CumulativeSends: 1121,
  },
  {
    Date: "2023-08-01",
    Clicks: 33,
    Opens: 81,
    Sends: 5,
    CumulativeClicks: 978,
    CumulativeOpens: 938,
    CumulativeSends: 1126,
  },
  {
    Date: "2023-08-02",
    Clicks: 33,
    Opens: 81,
    Sends: 5,
    CumulativeClicks: 1011,
    CumulativeOpens: 1019,
    CumulativeSends: 1131,
  },
  {
    Date: "2023-08-03",
    Clicks: 45,
    Opens: 19,
    Sends: 76,
    CumulativeClicks: 1056,
    CumulativeOpens: 1038,
    CumulativeSends: 1207,
  },
  {
    Date: "2023-08-04",
    Clicks: 12,
    Opens: 18,
    Sends: 68,
    CumulativeClicks: 1068,
    CumulativeOpens: 1056,
    CumulativeSends: 1275,
  },
  {
    Date: "2023-08-05",
    Clicks: 61,
    Opens: 37,
    Sends: 80,
    CumulativeClicks: 1129,
    CumulativeOpens: 1093,
    CumulativeSends: 1355,
  },
  {
    Date: "2023-08-06",
    Clicks: 4,
    Opens: 9,
    Sends: 25,
    CumulativeClicks: 1133,
    CumulativeOpens: 1102,
    CumulativeSends: 1380,
  },
  {
    Date: "2023-08-07",
    Clicks: 72,
    Opens: 79,
    Sends: 82,
    CumulativeClicks: 1205,
    CumulativeOpens: 1181,
    CumulativeSends: 1462,
  },
  {
    Date: "2023-08-08",
    Clicks: 1,
    Opens: 6,
    Sends: 85,
    CumulativeClicks: 1206,
    CumulativeOpens: 1187,
    CumulativeSends: 1547,
  },
  {
    Date: "2023-08-09",
    Clicks: 14,
    Opens: 84,
    Sends: 15,
    CumulativeClicks: 1220,
    CumulativeOpens: 1271,
    CumulativeSends: 1562,
  },
  {
    Date: "2023-08-10",
    Clicks: 4,
    Opens: 85,
    Sends: 7,
    CumulativeClicks: 1224,
    CumulativeOpens: 1356,
    CumulativeSends: 1569,
  },
  {
    Date: "2023-08-11",
    Clicks: 7,
    Opens: 48,
    Sends: 68,
    CumulativeClicks: 1231,
    CumulativeOpens: 1404,
    CumulativeSends: 1637,
  },
  {
    Date: "2023-08-12",
    Clicks: 23,
    Opens: 60,
    Sends: 38,
    CumulativeClicks: 1254,
    CumulativeOpens: 1464,
    CumulativeSends: 1675,
  },
];

export const mockEmailEngagement: EngagementCounts = {
  ClickThroughRate: 2,
  ClickToOpen: 59,
  OpenRate: 47,
  AvgSendSize: 67,
  Clicks: 65,
  Opens: 41,
  Sends: 27,
  Customers: 53,
  Emails: 0,
};

export const mockEmptyEmailEngagement: EngagementCounts = {
  ClickThroughRate: 0,
  ClickToOpen: 0,
  OpenRate: 0,
  AvgSendSize: 0,
  Clicks: 0,
  Opens: 0,
  Sends: 0,
  Customers: 0,
  Emails: 0,
};

export const mockEmailDetails: EmailDetails[] = [
  {
    EmailId: 62620,
    EmailTitle: "mockEmailTitle",
    LastActivity: "2022-07-02 11:44:06.965",
    Sends: 3,
    Opens: 2,
    Clicks: 1,
    ClickThroughRate: 0.4,
    ClickToOpenRate: 0.2,
  },
  {
    EmailId: 2,
    EmailTitle: "title2",
    LastActivity: "2022-07-11 14:22:33.123",
    Sends: 61,
    Opens: 76,
    Clicks: 94,
    ClickThroughRate: 0.7,
    ClickToOpenRate: 0.1,
  },
  {
    EmailId: 81,
    EmailTitle: "title1",
    LastActivity: "2022-07-02 09:15:45.678",
    Sends: 87,
    Opens: 71,
    Clicks: 13,
    ClickThroughRate: 0.1,
    ClickToOpenRate: 0.9,
  },
  {
    EmailId: 45,
    EmailTitle: "title2",
    LastActivity: "2022-07-11 16:30:12.456",
    Sends: 61,
    Opens: 76,
    Clicks: 94,
    ClickThroughRate: 0.73,
    ClickToOpenRate: 0.12,
  },
  {
    EmailId: 81,
    EmailTitle: "title1",
    LastActivity: "2022-07-02 10:05:23.789",
    Sends: 87,
    Opens: 71,
    Clicks: 13,
    ClickThroughRate: 0.1,
    ClickToOpenRate: 0.9,
  },
  {
    EmailId: 33,
    EmailTitle: "title2",
    LastActivity: "2022-07-11 13:45:56.234",
    Sends: 61,
    Opens: 76,
    Clicks: 94,
    ClickThroughRate: 0.5,
    ClickToOpenRate: 0.5,
  },
  {
    EmailId: 58,
    EmailTitle: "title1",
    LastActivity: "2022-07-02 08:22:11.345",
    Sends: 87,
    Opens: 71,
    Clicks: 13,
    ClickThroughRate: 0.4,
    ClickToOpenRate: 0.7,
  },
  {
    EmailId: 76,
    EmailTitle: "title2",
    LastActivity: "2022-07-11 17:55:44.567",
    Sends: 61,
    Opens: 76,
    Clicks: 94,
    ClickThroughRate: 0.6,
    ClickToOpenRate: 0.3,
  },
  {
    EmailId: 14,
    EmailTitle: "title1",
    LastActivity: "2022-07-02 12:34:56.789",
    Sends: 55,
    Opens: 32,
    Clicks: 64,
    ClickThroughRate: 0.3,
    ClickToOpenRate: 0.8,
  },
  {
    EmailId: 22,
    EmailTitle: "title2",
    LastActivity: "2022-07-11 15:45:23.456",
    Sends: 62,
    Opens: 93,
    Clicks: 39,
    ClickThroughRate: 0.2,
    ClickToOpenRate: 0.15,
  },
];

export const mockFlowDailyData: AssetActivityCounts[] = [
  {
    Completed: 0,
    CompletedTotal: 0,
    Date: "2023-06-18",
    InProgress: 0,
    InProgressTotal: 0,
    NotStarted: 0,
    Users: 0,
  },
  {
    Completed: 1,
    CompletedTotal: 1,
    Date: "2023-06-19",
    InProgress: 0,
    InProgressTotal: 0,
    NotStarted: 0,
    Users: 1,
  },
  {
    Completed: 0,
    CompletedTotal: 1,
    Date: "2023-06-20",
    InProgress: 0,
    InProgressTotal: 0,
    NotStarted: 0,
    Users: 0,
  },
  {
    Completed: 0,
    CompletedTotal: 1,
    Date: "2023-06-21",
    InProgress: 0,
    InProgressTotal: 0,
    NotStarted: 0,
    Users: 0,
  },
  {
    Completed: 1,
    CompletedTotal: 2,
    Date: "2023-06-22",
    InProgress: 0,
    InProgressTotal: 0,
    NotStarted: 0,
    Users: 1,
  },
  {
    Completed: 0,
    CompletedTotal: 2,
    Date: "2023-06-23",
    InProgress: 1,
    InProgressTotal: 1,
    NotStarted: 0,
    Users: 1,
  },
  {
    Completed: 0,
    CompletedTotal: 2,
    Date: "2023-06-24",
    InProgress: 0,
    InProgressTotal: 1,
    NotStarted: 0,
    Users: 0,
  },
  {
    Completed: 0,
    CompletedTotal: 2,
    Date: "2023-06-25",
    InProgress: 0,
    InProgressTotal: 1,
    NotStarted: 0,
    Users: 0,
  },
  {
    Completed: 1,
    CompletedTotal: 3,
    Date: "2023-06-26",
    InProgress: 1,
    InProgressTotal: 2,
    NotStarted: 0,
    Users: 1,
  },
  {
    Completed: 0,
    CompletedTotal: 3,
    Date: "2023-06-27",
    InProgress: 0,
    InProgressTotal: 2,
    NotStarted: 0,
    Users: 0,
  },
];

export const mockFlowEngagement: FlowCards = {
  Customers: 10,
  AverageCustomerSize: 20,
  AverageFlowsUser: 30,
  Flows: 40,
  Users: 50,
  Started: 60,
  Completed: 70,
  Retaken: 80,
};

export const mockFlowEmptyLine: AssetActivityCounts = {
  Completed: 0,
  CompletedTotal: 0,
  Date: "2023-06-18",
  InProgress: 0,
  InProgressTotal: 0,
  NotStarted: 0,
  Users: 0,
};

export const mockFlowEmptyEngagement: FlowCards = {
  Customers: 0,
  AverageCustomerSize: 0,
  AverageFlowsUser: 0,
  Flows: 0,
  Users: 0,
  Completed: 0,
  Started: 0,
  Retaken: 0,
};

export const mockFlowDetails: FlowDetails[] = [
  {
    Completed: 1,
    FlowId: 1056098,
    Goal: "Remediation",
    Started: 0,
    LastActivity: "2023-06-19T13:28:56.024",
    Status: "Published",
    Title: "ewqeqwewqe",
    Users: 1,
  },
];

export const mockBarData: DataPoint[] = [
  {
    id: starts.toLowerCase(),
    category: starts,
    value: 0,
    fillColor: reportingColors.blue,
  },
  {
    id: completes.toLowerCase(),
    category: completes,
    value: 0,
    fillColor: reportingColors.yellow,
  },
];

export const mockCardData: CardReportingItem[] = [
  {
    stat: 0,
    popupBody: "Customer popupBody",
    statDescription: "Customers",
  },
  {
    stat: 0,
    popupBody: "Avg. Customer Size popupBody",
    statDescription: "Avg. Customer Size",
  },
  {
    stat: 0,
    popupBody: "Flows popupBody",
    statDescription: "Flows",
  },
  {
    stat: 0,
    popupBody: "Users popupBody",
    statDescription: "Users",
  },
  {
    stat: 0,
    popupBody: "Avg. Flows/User popupBody",
    statDescription: "Avg. Flows/User",
  },
];

export const mockVideoDailyData: VideoActivityCounts[] = [
  {
    Date: "2023-07-27",
    CompletedCount: 24,
    CumulativeCompletedCount: 27,
    CumulativeStartedCount: 82,
    StartedCount: 34,
  },
  {
    Date: "2023-07-28",
    CompletedCount: 61,
    CumulativeCompletedCount: 44,
    CumulativeStartedCount: 70,
    StartedCount: 12,
  },
  {
    Date: "2023-07-29",
    CompletedCount: 96,
    CumulativeCompletedCount: 3,
    CumulativeStartedCount: 17,
    StartedCount: 71,
  },
  {
    Date: "2023-07-30",
    CompletedCount: 43,
    CumulativeCompletedCount: 76,
    CumulativeStartedCount: 80,
    StartedCount: 33,
  },
  {
    Date: "2023-07-31",
    CompletedCount: 26,
    CumulativeCompletedCount: 46,
    CumulativeStartedCount: 38,
    StartedCount: 94,
  },
  {
    Date: "2023-08-01",
    CompletedCount: 11,
    CumulativeCompletedCount: 57,
    CumulativeStartedCount: 80,
    StartedCount: 33,
  },
  {
    Date: "2023-08-01",
    CompletedCount: 84,
    CumulativeCompletedCount: 52,
    CumulativeStartedCount: 74,
    StartedCount: 83,
  },
  {
    Date: "2023-08-02",
    CompletedCount: 16,
    CumulativeCompletedCount: 60,
    CumulativeStartedCount: 22,
    StartedCount: 98,
  },
  {
    Date: "2023-08-03",
    CompletedCount: 35,
    CumulativeCompletedCount: 15,
    CumulativeStartedCount: 2,
    StartedCount: 99,
  },
  {
    Date: "2023-08-04",
    CompletedCount: 43,
    CumulativeCompletedCount: 93,
    CumulativeStartedCount: 70,
    StartedCount: 11,
  },
  {
    Date: "2023-08-05",
    CompletedCount: 94,
    CumulativeCompletedCount: 13,
    CumulativeStartedCount: 28,
    StartedCount: 26,
  },
  {
    Date: "2023-08-06",
    CompletedCount: 99,
    CumulativeCompletedCount: 22,
    CumulativeStartedCount: 91,
    StartedCount: 55,
  },
  {
    Date: "2023-08-07",
    CompletedCount: 19,
    CumulativeCompletedCount: 74,
    CumulativeStartedCount: 72,
    StartedCount: 83,
  },
  {
    Date: "2023-08-08",
    CompletedCount: 41,
    CumulativeCompletedCount: 20,
    CumulativeStartedCount: 77,
    StartedCount: 32,
  },
  {
    Date: "2023-08-09",
    CompletedCount: 85,
    CumulativeCompletedCount: 4,
    CumulativeStartedCount: 37,
    StartedCount: 89,
  },
  {
    Date: "2023-08-10",
    CompletedCount: 28,
    CumulativeCompletedCount: 30,
    CumulativeStartedCount: 8,
    StartedCount: 85,
  },
  {
    Date: "2023-08-11",
    CompletedCount: 14,
    CumulativeCompletedCount: 16,
    CumulativeStartedCount: 68,
    StartedCount: 2,
  },
  {
    Date: "2023-08-12",
    CompletedCount: 22,
    CumulativeCompletedCount: 77,
    CumulativeStartedCount: 95,
    StartedCount: 6,
  },
  {
    Date: "2023-08-13",
    CompletedCount: 39,
    CumulativeCompletedCount: 96,
    CumulativeStartedCount: 51,
    StartedCount: 95,
  },
  {
    Date: "2023-08-14",
    CompletedCount: 37,
    CumulativeCompletedCount: 49,
    CumulativeStartedCount: 25,
    StartedCount: 40,
  },
  {
    Date: "2023-08-15",
    CompletedCount: 96,
    CumulativeCompletedCount: 28,
    CumulativeStartedCount: 74,
    StartedCount: 66,
  },
  {
    Date: "2023-08-16",
    CompletedCount: 53,
    CumulativeCompletedCount: 18,
    CumulativeStartedCount: 82,
    StartedCount: 73,
  },
  {
    Date: "2023-08-17",
    CompletedCount: 6,
    CumulativeCompletedCount: 3,
    CumulativeStartedCount: 49,
    StartedCount: 23,
  },
  {
    Date: "2023-08-18",
    CompletedCount: 35,
    CumulativeCompletedCount: 1,
    CumulativeStartedCount: 44,
    StartedCount: 91,
  },
  {
    Date: "2023-08-19",
    CompletedCount: 92,
    CumulativeCompletedCount: 39,
    CumulativeStartedCount: 60,
    StartedCount: 99,
  },
  {
    Date: "2023-08-20",
    CompletedCount: 98,
    CumulativeCompletedCount: 81,
    CumulativeStartedCount: 22,
    StartedCount: 24,
  },
  {
    Date: "2023-08-21",
    CompletedCount: 66,
    CumulativeCompletedCount: 49,
    CumulativeStartedCount: 21,
    StartedCount: 77,
  },
  {
    Date: "2023-08-22",
    CompletedCount: 100,
    CumulativeCompletedCount: 91,
    CumulativeStartedCount: 69,
    StartedCount: 18,
  },
  {
    Date: "2023-08-23",
    CompletedCount: 16,
    CumulativeCompletedCount: 75,
    CumulativeStartedCount: 29,
    StartedCount: 8,
  },
  {
    Date: "2023-08-24",
    CompletedCount: 63,
    CumulativeCompletedCount: 93,
    CumulativeStartedCount: 28,
    StartedCount: 82,
  },
  {
    Date: "2023-08-25",
    CompletedCount: 85,
    CumulativeCompletedCount: 4,
    CumulativeStartedCount: 62,
    StartedCount: 80,
  },
  {
    Date: "2023-08-26",
    CompletedCount: 83,
    CumulativeCompletedCount: 41,
    CumulativeStartedCount: 78,
    StartedCount: 95,
  },
  {
    Date: "2023-08-27",
    CompletedCount: 68,
    CumulativeCompletedCount: 40,
    CumulativeStartedCount: 41,
    StartedCount: 80,
  },
];

export const mockVideoDailyEmptyData: VideoActivityCounts[] = [
  {
    Date: "2023-07-27",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
    CumulativeStartedCount: 0,
    StartedCount: 0,
  },
];

export const mockVideoEngagement: VideoEngagement = {
  CompletedCount: 54,
  StartedCount: 22,
};

export const mockVideoDetails: VideoDetails[] = [
  {
    VideoId: 55925,
    VideoTitle: "Video Title 1",
    LastActivity: "01/01/2011 01:11",
    TotalStarts: 62,
    TotalCompletes: 95,
    CompletionRate: 0.982345,
    VideoType: AssetTypes.EmbeddedVideo,
  },
  {
    VideoId: 8,
    VideoTitle: "Video Title 2",
    LastActivity: "02/02/2012 02:12",
    TotalStarts: 88,
    TotalCompletes: 48,
    CompletionRate: 0.71,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 62,
    VideoTitle: "Video Title 3",
    LastActivity: "03/03/2013 03:13",
    TotalStarts: 93,
    TotalCompletes: 13,
    CompletionRate: 0.613,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 32,
    VideoTitle: "Video Title 4",
    LastActivity: "04/04/2014 04:14",
    TotalStarts: 54,
    TotalCompletes: 51,
    CompletionRate: 0.322,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 24,
    VideoTitle: "Video Title 5",
    LastActivity: "05/05/2015 05:15",
    TotalStarts: 30,
    TotalCompletes: 77,
    CompletionRate: 0.022345,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 64,
    VideoTitle: "Video Title 6",
    LastActivity: "06/06/2016 06:16",
    TotalStarts: 59,
    TotalCompletes: 33,
    CompletionRate: 0.242,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 11,
    VideoTitle: "Video Title 7",
    LastActivity: "07/07/2017 07:17",
    TotalStarts: 30,
    TotalCompletes: 77,
    CompletionRate: 0.022345,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 34,
    VideoTitle: "Video Title 8",
    LastActivity: "08/08/2018 08:18",
    TotalStarts: 59,
    TotalCompletes: 33,
    CompletionRate: 0.58,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 75,
    VideoTitle: "Video Title 9",
    LastActivity: "09/09/2019 09:19",
    TotalStarts: 30,
    TotalCompletes: 77,
    CompletionRate: 0.022345,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 74,
    VideoTitle: "Video Title 10",
    LastActivity: "10/10/2020 10:20",
    TotalStarts: 89,
    TotalCompletes: 8,
    CompletionRate: 0.752,
    VideoType: AssetTypes.Video,
  },
  {
    VideoId: 82,
    VideoTitle: "Video Title 11",
    LastActivity: "11/11/2021 11:21",
    TotalStarts: 30,
    TotalCompletes: 77,
    CompletionRate: 0.022345,
    VideoType: AssetTypes.EmbeddedVideo,
  },
  {
    VideoId: 96,
    VideoTitle: "Video Title 12",
    LastActivity: "12/12/2022 12:22",
    TotalStarts: 47,
    TotalCompletes: 13,
    CompletionRate: 0.93234,
    VideoType: AssetTypes.Video,
  },
];

export const mockAssessmentActivity: AssessmentActivityCounts[] = [
  {
    Date: "2023-07-27",
    Completed: 60,
    CumulativeCompleted: 84,
    Started: 45,
    CumulativeStarted: 3,
    AssessmentId: -1,
  },
  {
    Date: "2023-07-28",
    Completed: 24,
    CumulativeCompleted: 12,
    Started: 59,
    CumulativeStarted: 53,
    AssessmentId: -1,
  },
  {
    Date: "2023-07-29",
    Completed: 54,
    CumulativeCompleted: 100,
    Started: 88,
    CumulativeStarted: 61,
    AssessmentId: -1,
  },
  {
    Date: "2023-07-30",
    Completed: 76,
    CumulativeCompleted: 58,
    Started: 58,
    CumulativeStarted: 79,
    AssessmentId: -1,
  },
  {
    Date: "2023-07-31",
    Completed: 41,
    CumulativeCompleted: 6,
    Started: 40,
    CumulativeStarted: 59,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-01",
    Completed: 83,
    CumulativeCompleted: 1,
    Started: 4,
    CumulativeStarted: 15,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-02",
    Completed: 17,
    CumulativeCompleted: 29,
    Started: 25,
    CumulativeStarted: 92,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-03",
    Completed: 19,
    CumulativeCompleted: 85,
    Started: 32,
    CumulativeStarted: 15,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-04",
    Completed: 37,
    CumulativeCompleted: 6,
    Started: 40,
    CumulativeStarted: 3,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-05",
    Completed: 94,
    CumulativeCompleted: 13,
    Started: 43,
    CumulativeStarted: 6,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-06",
    Completed: 83,
    CumulativeCompleted: 36,
    Started: 73,
    CumulativeStarted: 77,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-07",
    Completed: 49,
    CumulativeCompleted: 99,
    Started: 14,
    CumulativeStarted: 5,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-08",
    Completed: 14,
    CumulativeCompleted: 17,
    Started: 8,
    CumulativeStarted: 15,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-09",
    Completed: 75,
    CumulativeCompleted: 97,
    Started: 4,
    CumulativeStarted: 77,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-10",
    Completed: 45,
    CumulativeCompleted: 45,
    Started: 28,
    CumulativeStarted: 30,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-11",
    Completed: 42,
    CumulativeCompleted: 15,
    Started: 16,
    CumulativeStarted: 27,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-12",
    Completed: 58,
    CumulativeCompleted: 11,
    Started: 8,
    CumulativeStarted: 44,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-13",
    Completed: 62,
    CumulativeCompleted: 34,
    Started: 24,
    CumulativeStarted: 1,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-14",
    Completed: 23,
    CumulativeCompleted: 75,
    Started: 48,
    CumulativeStarted: 76,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-15",
    Completed: 92,
    CumulativeCompleted: 92,
    Started: 95,
    CumulativeStarted: 30,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-16",
    Completed: 66,
    CumulativeCompleted: 48,
    Started: 38,
    CumulativeStarted: 50,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-17",
    Completed: 28,
    CumulativeCompleted: 76,
    Started: 23,
    CumulativeStarted: 42,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-18",
    Completed: 95,
    CumulativeCompleted: 8,
    Started: 47,
    CumulativeStarted: 29,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-19",
    Completed: 19,
    CumulativeCompleted: 3,
    Started: 88,
    CumulativeStarted: 96,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-20",
    Completed: 87,
    CumulativeCompleted: 100,
    Started: 69,
    CumulativeStarted: 37,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-21",
    Completed: 42,
    CumulativeCompleted: 65,
    Started: 51,
    CumulativeStarted: 86,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-22",
    Completed: 9,
    CumulativeCompleted: 34,
    Started: 15,
    CumulativeStarted: 92,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-23",
    Completed: 71,
    CumulativeCompleted: 93,
    Started: 51,
    CumulativeStarted: 29,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-24",
    Completed: 38,
    CumulativeCompleted: 87,
    Started: 4,
    CumulativeStarted: 93,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-25",
    Completed: 52,
    CumulativeCompleted: 9,
    Started: 55,
    CumulativeStarted: 27,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-26",
    Completed: 78,
    CumulativeCompleted: 11,
    Started: 6,
    CumulativeStarted: 95,
    AssessmentId: -1,
  },
  {
    Date: "2023-08-27",
    Completed: 92,
    CumulativeCompleted: 54,
    Started: 43,
    CumulativeStarted: 8,
    AssessmentId: -1,
  },
];

export const mockAssessmentActivityEmpty: AssessmentActivityCounts[] = [
  {
    CumulativeCompleted: 0,
    Completed: 0,
    Date: "2023-07-27",
    CumulativeStarted: 0,
    Started: 0,
    AssessmentId: -1,
  },
];

export const mockAssessmentEngagement: AssessmentEngagement = {
  AccountId: 1,
  AverageGrade: 75,
  AverageTime: 120,
  CompletionRate: 85,
  Started: 70,
  Completed: 85,
  Customers: 100,
  PassingGrade: 80,
};

export const mockAssessmentDetails: AssessmentDetails[] = [
  {
    AssessmentId: 33607,
    AssessmentTitle: "Assessment 1",
    LastActivity: "01/01/2023 01:01",
    TotalStarts: 63,
    TotalCompletes: 27,
    CompletionRate: 71.1435432,
    AverageTime: 93,
    AverageGrade: 25.245,
  },
  {
    AssessmentId: 89,
    AssessmentTitle: "Assessment 2",
    LastActivity: "02/02/2023 02:02",
    TotalStarts: 67,
    TotalCompletes: 52,
    CompletionRate: 31.4,
    AverageTime: 17,
    AverageGrade: 69.13,
  },
  {
    AssessmentId: 92,
    AssessmentTitle: "Assessment 3",
    LastActivity: "03/03/2023 03:03",
    TotalStarts: 14,
    TotalCompletes: 51,
    CompletionRate: 22,
    AverageTime: 5420,
    AverageGrade: 2.3,
  },
  {
    AssessmentId: 24,
    AssessmentTitle: "Assessment 4",
    LastActivity: "04/04/2023 04:04",
    TotalStarts: 100,
    TotalCompletes: 27,
    CompletionRate: 59,
    AverageTime: 58,
    AverageGrade: 23,
  },
  {
    AssessmentId: 1,
    AssessmentTitle: "Assessment 5",
    LastActivity: "05/05/2023 05:05",
    TotalStarts: 93,
    TotalCompletes: 90,
    CompletionRate: 44,
    AverageTime: 50,
    AverageGrade: 98,
  },
  {
    AssessmentId: 10,
    AssessmentTitle: "Assessment 6",
    LastActivity: "06/06/2023 06:06",
    TotalStarts: 59,
    TotalCompletes: 9,
    CompletionRate: 22,
    AverageTime: 87,
    AverageGrade: 20,
  },
  {
    AssessmentId: 61,
    AssessmentTitle: "Assessment 7",
    LastActivity: "07/07/2023 07:07",
    TotalStarts: 94,
    TotalCompletes: 63,
    CompletionRate: 55,
    AverageTime: 83,
    AverageGrade: 81,
  },
  {
    AssessmentId: 98,
    AssessmentTitle: "Assessment 8",
    LastActivity: "08/08/2023 08:08",
    TotalStarts: 69,
    TotalCompletes: 50,
    CompletionRate: 45,
    AverageTime: 85,
    AverageGrade: 61,
  },
  {
    AssessmentId: 99,
    AssessmentTitle: "Assessment 9",
    LastActivity: "09/09/2023 09:09",
    TotalStarts: 7,
    TotalCompletes: 14,
    CompletionRate: 71,
    AverageTime: 93,
    AverageGrade: 67,
  },
  {
    AssessmentId: 44,
    AssessmentTitle: "Assessment 10",
    LastActivity: "10/10/2023 10:10",
    TotalStarts: 45,
    TotalCompletes: 22,
    CompletionRate: 92,
    AverageTime: 50,
    AverageGrade: 24,
  },
  {
    AssessmentId: 4,
    AssessmentTitle: "Assessment 11",
    LastActivity: "11/11/2023 11:11",
    TotalStarts: 48,
    TotalCompletes: 6,
    CompletionRate: 91,
    AverageTime: 10,
    AverageGrade: 61,
  },
  {
    AssessmentId: 33,
    AssessmentTitle: "Assessment 12",
    LastActivity: "12/12/2023 12:12",
    TotalStarts: 23,
    TotalCompletes: 90,
    CompletionRate: 9,
    AverageTime: 63,
    AverageGrade: 74,
  },
  {
    AssessmentId: 29,
    AssessmentTitle: "Assessment 13",
    LastActivity: "12/13/2023 12:13",
    TotalStarts: 26,
    TotalCompletes: 17,
    CompletionRate: 78,
    AverageTime: 83,
    AverageGrade: 98,
  },
];

export const mockSurveyActivity: SurveyActivityCounts[] = [
  {
    Date: "2023-07-27",
    Events: {
      CompletedCount: 76,
      CumulativeCompletedCount: 4,
      StartedCount: 45,
      CumulativeStartedCount: 3,
    },
  },
  {
    Date: "2023-07-28",
    Events: {
      CompletedCount: 12,
      CumulativeCompletedCount: 5,
      StartedCount: 12,
      CumulativeStartedCount: 5,
    },
  },
  {
    Date: "2023-07-29",
    Events: {
      CompletedCount: 37,
      CumulativeCompletedCount: 41,
      StartedCount: 37,
      CumulativeStartedCount: 41,
    },
  },
  {
    Date: "2023-07-30",
    Events: {
      CompletedCount: 74,
      CumulativeCompletedCount: 33,
      StartedCount: 74,
      CumulativeStartedCount: 33,
    },
  },
  {
    Date: "2023-07-31",
    Events: {
      CompletedCount: 48,
      CumulativeCompletedCount: 15,
      StartedCount: 48,
      CumulativeStartedCount: 15,
    },
  },
  {
    Date: "2023-08-01",
    Events: {
      CompletedCount: 20,
      CumulativeCompletedCount: 55,
      StartedCount: 20,
      CumulativeStartedCount: 55,
    },
  },
  {
    Date: "2023-08-02",
    Events: {
      CompletedCount: 41,
      CumulativeCompletedCount: 46,
      StartedCount: 41,
      CumulativeStartedCount: 46,
    },
  },
  {
    Date: "2023-08-03",
    Events: {
      CompletedCount: 96,
      CumulativeCompletedCount: 97,
      StartedCount: 96,
      CumulativeStartedCount: 97,
    },
  },
  {
    Date: "2023-08-04",
    Events: {
      CompletedCount: 18,
      CumulativeCompletedCount: 48,
      StartedCount: 18,
      CumulativeStartedCount: 48,
    },
  },
  {
    Date: "2023-08-05",
    Events: {
      CompletedCount: 98,
      CumulativeCompletedCount: 89,
      StartedCount: 98,
      CumulativeStartedCount: 89,
    },
  },
  {
    Date: "2023-08-06",
    Events: {
      CompletedCount: 11,
      CumulativeCompletedCount: 74,
      StartedCount: 11,
      CumulativeStartedCount: 74,
    },
  },
  {
    Date: "2023-08-07",
    Events: {
      CompletedCount: 23,
      CumulativeCompletedCount: 44,
      StartedCount: 23,
      CumulativeStartedCount: 44,
    },
  },
  {
    Date: "2023-08-08",
    Events: {
      CompletedCount: 49,
      CumulativeCompletedCount: 46,
      StartedCount: 49,
      CumulativeStartedCount: 46,
    },
  },
  {
    Date: "2023-08-09",
    Events: {
      CompletedCount: 52,
      CumulativeCompletedCount: 37,
      StartedCount: 52,
      CumulativeStartedCount: 37,
    },
  },
  {
    Date: "2023-08-10",
    Events: {
      CompletedCount: 28,
      CumulativeCompletedCount: 71,
      StartedCount: 28,
      CumulativeStartedCount: 71,
    },
  },
  {
    Date: "2023-08-11",
    Events: {
      CompletedCount: 7,
      CumulativeCompletedCount: 11,
      StartedCount: 7,
      CumulativeStartedCount: 11,
    },
  },
  {
    Date: "2023-08-12",
    Events: {
      CompletedCount: 7,
      CumulativeCompletedCount: 76,
      StartedCount: 7,
      CumulativeStartedCount: 76,
    },
  },
  {
    Date: "2023-08-13",
    Events: {
      CompletedCount: 62,
      CumulativeCompletedCount: 67,
      StartedCount: 62,
      CumulativeStartedCount: 67,
    },
  },
  {
    Date: "2023-08-14",
    Events: {
      CompletedCount: 23,
      CumulativeCompletedCount: 38,
      StartedCount: 23,
      CumulativeStartedCount: 38,
    },
  },
  {
    Date: "2023-08-15",
    Events: {
      CompletedCount: 17,
      CumulativeCompletedCount: 44,
      StartedCount: 17,
      CumulativeStartedCount: 44,
    },
  },
  {
    Date: "2023-08-16",
    Events: {
      CompletedCount: 60,
      CumulativeCompletedCount: 60,
      StartedCount: 60,
      CumulativeStartedCount: 60,
    },
  },
  {
    Date: "2023-08-17",
    Events: {
      CompletedCount: 100,
      CumulativeCompletedCount: 14,
      StartedCount: 100,
      CumulativeStartedCount: 14,
    },
  },
  {
    Date: "2023-08-18",
    Events: {
      CompletedCount: 51,
      CumulativeCompletedCount: 77,
      StartedCount: 51,
      CumulativeStartedCount: 77,
    },
  },
  {
    Date: "2023-08-19",
    Events: {
      CompletedCount: 27,
      CumulativeCompletedCount: 84,
      StartedCount: 27,
      CumulativeStartedCount: 84,
    },
  },
  {
    Date: "2023-08-20",
    Events: {
      CompletedCount: 60,
      CumulativeCompletedCount: 23,
      StartedCount: 60,
      CumulativeStartedCount: 23,
    },
  },
  {
    Date: "2023-08-21",
    Events: {
      CompletedCount: 95,
      CumulativeCompletedCount: 82,
      StartedCount: 95,
      CumulativeStartedCount: 82,
    },
  },
  {
    Date: "2023-08-22",
    Events: {
      CompletedCount: 98,
      CumulativeCompletedCount: 30,
      StartedCount: 98,
      CumulativeStartedCount: 30,
    },
  },
  {
    Date: "2023-08-23",
    Events: {
      CompletedCount: 6,
      CumulativeCompletedCount: 29,
      StartedCount: 6,
      CumulativeStartedCount: 29,
    },
  },
  {
    Date: "2023-08-24",
    Events: {
      CompletedCount: 87,
      CumulativeCompletedCount: 82,
      StartedCount: 87,
      CumulativeStartedCount: 82,
    },
  },
  {
    Date: "2023-08-25",
    Events: {
      CompletedCount: 12,
      CumulativeCompletedCount: 40,
      StartedCount: 12,
      CumulativeStartedCount: 40,
    },
  },
  {
    Date: "2023-08-26",
    Events: {
      CompletedCount: 65,
      CumulativeCompletedCount: 65,
      StartedCount: 65,
      CumulativeStartedCount: 65,
    },
  },
  {
    Date: "2023-08-27",
    Events: {
      CompletedCount: 95,
      CumulativeCompletedCount: 72,
      StartedCount: 95,
      CumulativeStartedCount: 72,
    },
  },
];

export const mockSurveyActivityEmpty: SurveyActivityCounts[] = [
  {
    Date: "2023-07-27",
    Events: {
      CompletedCount: 0,
      CumulativeCompletedCount: 0,
      StartedCount: 0,
      CumulativeStartedCount: 0,
    },
  },
];

export const mockSurveyEngagement: SurveyEngagement = {
  AverageTime: 41,
  CompletionRate: 45,
  Completions: 3,
  Customers: 24,
  Started: 10,
};

export const mockSurveyDetails: SurveyDetails[] = [
  {
    SurveyId: 40801,
    SurveyTitle: "Survey 1",
    LastActivity: "01/01/2023 01:01",
    TotalStarts: 3,
    TotalCompletes: 11,
    CompletionRate: 48.1451,
    AverageTime: 3,
  },
  {
    SurveyId: 1,
    SurveyTitle: "Survey 2",
    LastActivity: "02/02/2023 02:02",
    TotalStarts: 22,
    TotalCompletes: 8,
    CompletionRate: 29.56,
    AverageTime: 69,
  },
  {
    SurveyId: 59,
    SurveyTitle: "Survey 3",
    LastActivity: "03/03/2023 03:03",
    TotalStarts: 95,
    TotalCompletes: 84,
    CompletionRate: 9.3,
    AverageTime: 5420,
  },
  {
    SurveyId: 2,
    SurveyTitle: "Survey 4",
    LastActivity: "04/04/2023 04:04",
    TotalStarts: 75,
    TotalCompletes: 6,
    CompletionRate: 71,
    AverageTime: 31,
  },
  {
    SurveyId: 40,
    SurveyTitle: "Survey 5",
    LastActivity: "05/05/2023 05:05",
    TotalStarts: 78,
    TotalCompletes: 27,
    CompletionRate: 67,
    AverageTime: 16,
  },
  {
    SurveyId: 81,
    SurveyTitle: "Survey 6",
    LastActivity: "06/06/2023 06:06",
    TotalStarts: 28,
    TotalCompletes: 59,
    CompletionRate: 23,
    AverageTime: 12,
  },
  {
    SurveyId: 68,
    SurveyTitle: "Survey 7",
    LastActivity: "07/07/2023 07:07",
    TotalStarts: 22,
    TotalCompletes: 91,
    CompletionRate: 55,
    AverageTime: 50,
  },
  {
    SurveyId: 93,
    SurveyTitle: "Survey 8",
    LastActivity: "08/08/2023 08:08",
    TotalStarts: 68,
    TotalCompletes: 81,
    CompletionRate: 77,
    AverageTime: 89,
  },
  {
    SurveyId: 76,
    SurveyTitle: "Survey 9",
    LastActivity: "09/09/2023 09:09",
    TotalStarts: 82,
    TotalCompletes: 14,
    CompletionRate: 34,
    AverageTime: 47,
  },
  {
    SurveyId: 74,
    SurveyTitle: "Survey 10",
    LastActivity: "10/10/2023 10:10",
    TotalStarts: 6,
    TotalCompletes: 95,
    CompletionRate: 70,
    AverageTime: 74,
  },
  {
    SurveyId: 99,
    SurveyTitle: "Survey 11",
    LastActivity: "11/11/2023 11:11",
    TotalStarts: 70,
    TotalCompletes: 92,
    CompletionRate: 10,
    AverageTime: 51,
  },
  {
    SurveyId: 25,
    SurveyTitle: "Survey 12",
    LastActivity: "12/12/2023 12:12",
    TotalStarts: 5,
    TotalCompletes: 41,
    CompletionRate: 5,
    AverageTime: 25,
  },
  {
    SurveyId: 63,
    SurveyTitle: "Survey 13",
    LastActivity: "12/13/2023 12:13",
    TotalStarts: 64,
    TotalCompletes: 45,
    CompletionRate: 30,
    AverageTime: 47,
  },
];

export const mockPdfDailyData: EngagementLineData[] = [
  {
    Date: "2023-07-02T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-03T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-04T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-05T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-06T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-07T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-08T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-09T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-10T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-11T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-12T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-13T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-14T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-15T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-16T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-17T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-18T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-19T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-20T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-21T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-22T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-23T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-24T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-25T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-26T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-27T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-28T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-29T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-30T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
  {
    Date: "2023-07-31T00:00:00.000",
    CompletedCount: 0,
    CumulativeCompletedCount: 0,
  },
];

export const mockPdfEngagementData: EngagementHorizontalData = {
  CompletedCount: 10,
  Customers: 20,
  PDFs: 30,
};

export const mockEmptyPdfEngagementData: EngagementHorizontalData = {
  CompletedCount: 0,
  Customers: 0,
  PDFs: 0,
};

export const mockPdfDetailsData: PdfDetails[] = [
  {
    CompletedCount: 0,
    LastActivityDate: "2023-07-31",
    PdfId: 1,
    Account: "Account 1",
    AccountId: 1,
    PdfTitle: "13july for purchasing",
  },
  {
    CompletedCount: 0,
    LastActivityDate: "2023-07-31",
    PdfId: 2,
    Account: "Account 2",
    AccountId: 2,
    PdfTitle: "13july for purchasing",
  },
  {
    CompletedCount: 0,
    LastActivityDate: "2023-07-31",
    PdfId: 3,
    Account: "Account 3",
    AccountId: 3,
    PdfTitle: "345345tret",
  },
  {
    CompletedCount: 0,
    LastActivityDate: "2023-07-09",
    PdfId: 4,
    Account: "Account 4",
    AccountId: 4,
    PdfTitle: "Clean.Code.A.Handbook.of.Agile.Software.Craftsmanship",
  },
  {
    CompletedCount: 0,
    LastActivityDate: "2023-07-17",
    PdfId: 5,
    Account: "Account 5",
    AccountId: 5,
    PdfTitle: "DEMO Performance",
  },
];

export const mockEventsTableData: EventsTableEntity[] = [
  {
    EventId: 1,
    EventTitle: "Event 1",
    Registered: 50,
    Attended: 40,
    NotAttended: 10,
    LastActivity: "2024-02-05 15:28:13",
  },
  {
    EventId: 2,
    EventTitle: "Event 2",
    Registered: 30,
    Attended: 25,
    NotAttended: 5,
    LastActivity: "2024-02-06 10:15:22",
  },
  {
    EventId: 3,
    EventTitle: "Event 3",
    Registered: 20,
    Attended: 15,
    NotAttended: 5,
    LastActivity: "2024-02-07 14:45:01",
  },
  {
    EventId: 4,
    EventTitle: "Event 4",
    Registered: 60,
    Attended: 55,
    NotAttended: 5,
    LastActivity: "2024-02-08 09:30:18",
  },
  {
    EventId: 5,
    EventTitle: "Event 5",
    Registered: 80,
    Attended: 70,
    NotAttended: 10,
    LastActivity: "2024-02-09 16:55:42",
  },
];

/**
 * Phishing Campaign mock data
 */

export const mockPhishingCampaignEngagement: PhishingCampaignEngagementData = {
  EmailsSent: 1250,
  EmailsOpened: 487,
  EmailsClicked: 92,
  DataSubmitted: 23,
};

export const mockPhishingCampaignLineData: PhishingCampaignLineData[] = [
  {
    Date: "2024-01-01",
    EmailsSent: 45,
    EmailsOpened: 12,
    EmailsClicked: 3,
    DataSubmitted: 1,
  },
  {
    Date: "2024-01-02",
    EmailsSent: 67,
    EmailsOpened: 23,
    EmailsClicked: 7,
    DataSubmitted: 2,
  },
  {
    Date: "2024-01-03",
    EmailsSent: 52,
    EmailsOpened: 18,
    EmailsClicked: 4,
    DataSubmitted: 0,
  },
  {
    Date: "2024-01-04",
    EmailsSent: 89,
    EmailsOpened: 34,
    EmailsClicked: 8,
    DataSubmitted: 3,
  },
  {
    Date: "2024-01-05",
    EmailsSent: 73,
    EmailsOpened: 29,
    EmailsClicked: 6,
    DataSubmitted: 1,
  },
  {
    Date: "2024-01-06",
    EmailsSent: 41,
    EmailsOpened: 15,
    EmailsClicked: 2,
    DataSubmitted: 0,
  },
  {
    Date: "2024-01-07",
    EmailsSent: 96,
    EmailsOpened: 38,
    EmailsClicked: 9,
    DataSubmitted: 4,
  },
  {
    Date: "2024-01-08",
    EmailsSent: 58,
    EmailsOpened: 21,
    EmailsClicked: 5,
    DataSubmitted: 1,
  },
  {
    Date: "2024-01-09",
    EmailsSent: 64,
    EmailsOpened: 26,
    EmailsClicked: 7,
    DataSubmitted: 2,
  },
  {
    Date: "2024-01-10",
    EmailsSent: 78,
    EmailsOpened: 31,
    EmailsClicked: 6,
    DataSubmitted: 1,
  },
  {
    Date: "2024-01-11",
    EmailsSent: 35,
    EmailsOpened: 14,
    EmailsClicked: 3,
    DataSubmitted: 0,
  },
  {
    Date: "2024-01-12",
    EmailsSent: 82,
    EmailsOpened: 33,
    EmailsClicked: 8,
    DataSubmitted: 3,
  },
  {
    Date: "2024-01-13",
    EmailsSent: 47,
    EmailsOpened: 19,
    EmailsClicked: 4,
    DataSubmitted: 1,
  },
  {
    Date: "2024-01-14",
    EmailsSent: 91,
    EmailsOpened: 37,
    EmailsClicked: 9,
    DataSubmitted: 2,
  },
  {
    Date: "2024-01-15",
    EmailsSent: 56,
    EmailsOpened: 22,
    EmailsClicked: 5,
    DataSubmitted: 1,
  },
];

export const mockPhishingCampaignChartData: PhishingCampaignChartData = {
  "Financial Scam": 25,
  "Malware Download": 18,
  Other: 12,
  "PII Phishing": 32,
  "Password Phishing": 28,
};

export const mockPhishingCampaignDetails: PhishingCampaignDetails[] = [
  {
    AccountId: 1001,
    AccountName: "TechCorp Industries",
    CampaignId: 5001,
    CampaignName: "Q1 Security Awareness - Banking Scam",
    CampaignType: "Financial Scam",
    EmailsSent: 250,
    EmailsOpened: 95,
    EmailsClicked: 18,
    DataSubmitted: 4,
  },
  {
    AccountId: 1002,
    AccountName: "Global Manufacturing Ltd",
    CampaignId: 5002,
    CampaignName: "Malware Detection Training",
    CampaignType: "Malware Download",
    EmailsSent: 180,
    EmailsOpened: 72,
    EmailsClicked: 14,
    DataSubmitted: 3,
  },
  {
    AccountId: 1003,
    AccountName: "Healthcare Systems Inc",
    CampaignId: 5003,
    CampaignName: "Password Security Campaign",
    CampaignType: "Password Phishing",
    EmailsSent: 320,
    EmailsOpened: 128,
    EmailsClicked: 25,
    DataSubmitted: 6,
  },
  {
    AccountId: 1001,
    AccountName: "TechCorp Industries",
    CampaignId: 5004,
    CampaignName: "Personal Information Protection",
    CampaignType: "PII Phishing",
    EmailsSent: 220,
    EmailsOpened: 88,
    EmailsClicked: 16,
    DataSubmitted: 2,
  },
  {
    AccountId: 1004,
    AccountName: "Educational Services",
    CampaignId: 5005,
    CampaignName: "General Security Awareness",
    CampaignType: "Other",
    EmailsSent: 150,
    EmailsOpened: 60,
    EmailsClicked: 11,
    DataSubmitted: 1,
  },
  {
    AccountId: 1002,
    AccountName: "Global Manufacturing Ltd",
    CampaignId: 5006,
    CampaignName: "Advanced Persistent Threats",
    CampaignType: "Malware Download",
    EmailsSent: 280,
    EmailsOpened: 112,
    EmailsClicked: 22,
    DataSubmitted: 5,
  },
  {
    AccountId: 1005,
    AccountName: "Financial Services Corp",
    CampaignId: 5007,
    CampaignName: "Credit Card Fraud Prevention",
    CampaignType: "Financial Scam",
    EmailsSent: 300,
    EmailsOpened: 120,
    EmailsClicked: 28,
    DataSubmitted: 7,
  },
  {
    AccountId: 1003,
    AccountName: "Healthcare Systems Inc",
    CampaignId: 5008,
    CampaignName: "HIPAA Compliance Training",
    CampaignType: "PII Phishing",
    EmailsSent: 195,
    EmailsOpened: 78,
    EmailsClicked: 15,
    DataSubmitted: 3,
  },
  {
    AccountId: 1006,
    AccountName: "Retail Chain Enterprise",
    CampaignId: 5009,
    CampaignName: "Customer Data Protection",
    CampaignType: "PII Phishing",
    EmailsSent: 240,
    EmailsOpened: 96,
    EmailsClicked: 19,
    DataSubmitted: 4,
  },
  {
    AccountId: 1004,
    AccountName: "Educational Services",
    CampaignId: 5010,
    CampaignName: "Multi-Factor Authentication",
    CampaignType: "Password Phishing",
    EmailsSent: 165,
    EmailsOpened: 66,
    EmailsClicked: 12,
    DataSubmitted: 2,
  },
];
export const mockLinkCounts: LinkCounts[] = [
  {
    Date: "2024-05-25",
    TotalClicks: 12,
    TotalPageVisits: 18,
    CumulativeClicks: 340,
    CumulativePageVisits: 456,
  },
  {
    Date: "2024-05-26",
    TotalClicks: 8,
    TotalPageVisits: 15,
    CumulativeClicks: 348,
    CumulativePageVisits: 471,
  },
  {
    Date: "2024-05-27",
    TotalClicks: 15,
    TotalPageVisits: 22,
    CumulativeClicks: 363,
    CumulativePageVisits: 493,
  },
  {
    Date: "2024-05-28",
    TotalClicks: 23,
    TotalPageVisits: 31,
    CumulativeClicks: 386,
    CumulativePageVisits: 524,
  },
  {
    Date: "2024-05-29",
    TotalClicks: 19,
    TotalPageVisits: 25,
    CumulativeClicks: 405,
    CumulativePageVisits: 549,
  },
  {
    Date: "2024-05-30",
    TotalClicks: 11,
    TotalPageVisits: 17,
    CumulativeClicks: 416,
    CumulativePageVisits: 566,
  },
  {
    Date: "2024-05-31",
    TotalClicks: 16,
    TotalPageVisits: 24,
    CumulativeClicks: 432,
    CumulativePageVisits: 590,
  },
  {
    Date: "2024-06-01",
    TotalClicks: 14,
    TotalPageVisits: 20,
    CumulativeClicks: 446,
    CumulativePageVisits: 610,
  },
  {
    Date: "2024-06-02",
    TotalClicks: 18,
    TotalPageVisits: 26,
    CumulativeClicks: 464,
    CumulativePageVisits: 636,
  },
  {
    Date: "2024-06-03",
    TotalClicks: 21,
    TotalPageVisits: 29,
    CumulativeClicks: 485,
    CumulativePageVisits: 665,
  },
  {
    Date: "2024-06-04",
    TotalClicks: 13,
    TotalPageVisits: 19,
    CumulativeClicks: 498,
    CumulativePageVisits: 684,
  },
  {
    Date: "2024-06-05",
    TotalClicks: 17,
    TotalPageVisits: 23,
    CumulativeClicks: 515,
    CumulativePageVisits: 707,
  },
  {
    Date: "2024-06-06",
    TotalClicks: 20,
    TotalPageVisits: 28,
    CumulativeClicks: 535,
    CumulativePageVisits: 735,
  },
  {
    Date: "2024-06-07",
    TotalClicks: 9,
    TotalPageVisits: 14,
    CumulativeClicks: 544,
    CumulativePageVisits: 749,
  },
  {
    Date: "2024-06-08",
    TotalClicks: 22,
    TotalPageVisits: 32,
    CumulativeClicks: 566,
    CumulativePageVisits: 781,
  },
  {
    Date: "2024-06-09",
    TotalClicks: 16,
    TotalPageVisits: 21,
    CumulativeClicks: 582,
    CumulativePageVisits: 802,
  },
  {
    Date: "2024-06-10",
    TotalClicks: 25,
    TotalPageVisits: 35,
    CumulativeClicks: 607,
    CumulativePageVisits: 837,
  },
  {
    Date: "2024-06-11",
    TotalClicks: 12,
    TotalPageVisits: 18,
    CumulativeClicks: 619,
    CumulativePageVisits: 855,
  },
  {
    Date: "2024-06-12",
    TotalClicks: 19,
    TotalPageVisits: 27,
    CumulativeClicks: 638,
    CumulativePageVisits: 882,
  },
  {
    Date: "2024-06-13",
    TotalClicks: 24,
    TotalPageVisits: 33,
    CumulativeClicks: 662,
    CumulativePageVisits: 915,
  },
  {
    Date: "2024-06-14",
    TotalClicks: 15,
    TotalPageVisits: 22,
    CumulativeClicks: 677,
    CumulativePageVisits: 937,
  },
  {
    Date: "2024-06-15",
    TotalClicks: 18,
    TotalPageVisits: 25,
    CumulativeClicks: 695,
    CumulativePageVisits: 962,
  },
  {
    Date: "2024-06-16",
    TotalClicks: 21,
    TotalPageVisits: 30,
    CumulativeClicks: 716,
    CumulativePageVisits: 992,
  },
  {
    Date: "2024-06-17",
    TotalClicks: 14,
    TotalPageVisits: 19,
    CumulativeClicks: 730,
    CumulativePageVisits: 1011,
  },
  {
    Date: "2024-06-18",
    TotalClicks: 26,
    TotalPageVisits: 37,
    CumulativeClicks: 756,
    CumulativePageVisits: 1048,
  },
  {
    Date: "2024-06-19",
    TotalClicks: 17,
    TotalPageVisits: 24,
    CumulativeClicks: 773,
    CumulativePageVisits: 1072,
  },
  {
    Date: "2024-06-20",
    TotalClicks: 20,
    TotalPageVisits: 28,
    CumulativeClicks: 793,
    CumulativePageVisits: 1100,
  },
  {
    Date: "2024-06-21",
    TotalClicks: 13,
    TotalPageVisits: 18,
    CumulativeClicks: 806,
    CumulativePageVisits: 1118,
  },
  {
    Date: "2024-06-22",
    TotalClicks: 23,
    TotalPageVisits: 31,
    CumulativeClicks: 829,
    CumulativePageVisits: 1149,
  },
  {
    Date: "2024-06-23",
    TotalClicks: 28,
    TotalPageVisits: 39,
    CumulativeClicks: 857,
    CumulativePageVisits: 1188,
  },
];

export const mockLinkEngagementCounts: LinkEngagementCounts = {
  TotalClickRate: 0.724254,
  TotalClicks: 8507,
  TotalPageVisits: 1188,
};

export const mockLinkDetails: LinkUserDetails[] = [
  {
    UserId: 1,
    AccountId: 1,
    LinkId: 101,
    Name: "John Smith with a long name that needs truncation",
    Email: "john.smith@company.com",
    JobTitle: "Software Engineer",
    Department: "Engineering",
    Status: "Clicked",
    LastActivity: "2024-06-20T12:34:56Z",
  },
  {
    UserId: 27683,
    AccountId: 2,
    LinkId: 102,
    Name: "John Doe from same account",
    Email: "sarah.johnson@company.com",
    JobTitle: "Marketing Manager",
    Department: "Marketing",
    Status: "Viewed",
    LastActivity: "2024-06-21T12:34:56Z",
  },
  {
    UserId: 3,
    AccountId: 1,
    LinkId: 103,
    Name: "Michael Brown",
    Email: "michael.brown@company.com",
    JobTitle: "Sales Representative",
    Department: "Sales",
    Status: "Clicked",
    LastActivity: "2024-06-22T12:34:56Z",
  },
  {
    UserId: 4,
    AccountId: 1,
    LinkId: 104,
    Name: "Emily Davis",
    Email: "emily.davis@company.com",
    JobTitle: "HR Specialist",
    Department: "Human Resources",
    Status: "Viewed",
    LastActivity: "2024-06-23T12:34:56Z",
  },
  {
    UserId: 5,
    AccountId: 1,
    LinkId: 105,
    Name: "David Wilson",
    Email: "david.wilson@company.com",
    JobTitle: "Product Manager",
    Department: "Product",
    Status: "Clicked",
    LastActivity: "2024-06-24T12:34:56Z",
  },
  {
    UserId: 6,
    AccountId: 1,
    LinkId: 106,
    Name: "Lisa Anderson",
    Email: "lisa.anderson@company.com",
    JobTitle: "Finance Analyst",
    Department: "Finance",
    Status: "Viewed",
    LastActivity: "2024-06-25T12:34:56Z",
  },
  {
    UserId: 7,
    AccountId: 1,
    LinkId: 107,
    Name: "Robert Taylor",
    Email: "robert.taylor@company.com",
    JobTitle: "DevOps Engineer",
    Department: "Engineering",
    Status: "Clicked",
    LastActivity: "2024-06-26T12:34:56Z",
  },
  {
    UserId: 8,
    AccountId: 1,
    LinkId: 108,
    Name: "Jennifer Martinez",
    Email: "jennifer.martinez@company.com",
    JobTitle: "UX Designer",
    Department: "Design",
    Status: "Viewed",
    LastActivity: "2024-06-27T12:34:56Z",
  },
  {
    UserId: 9,
    AccountId: 1,
    LinkId: 109,
    Name: "Christopher Lee",
    Email: "christopher.lee@company.com",
    JobTitle: "Data Analyst",
    Department: "Analytics",
    Status: "Clicked",
    LastActivity: "2024-06-28T12:34:56Z",
  },
  {
    UserId: 10,
    AccountId: 3,
    LinkId: 110,
    Name: "Amanda Rodriguez",
    Email: "amanda.rodriguez@company.com",
    JobTitle: "Operations Manager",
    Department: "Operations",
    Status: "Viewed",
    LastActivity: "2024-06-29T12:34:56Z",
  },
  {
    UserId: 11,
    AccountId: 1,
    LinkId: 111,
    Name: "Daniel Thompson",
    Email: "daniel.thompson@company.com",
    JobTitle: "Security Specialist",
    Department: "IT Security",
    Status: "Clicked",
    LastActivity: "2024-06-30T12:34:56Z",
  },
  {
    UserId: 12,
    AccountId: 1,
    LinkId: 112,
    Name: "Rachel Green",
    Email: "rachel.green@company.com",
    JobTitle: "Content Writer",
    Department: "Marketing",
    Status: "Viewed",
    LastActivity: "2024-07-01T12:34:56Z",
  },
  {
    UserId: 13,
    AccountId: 2,
    LinkId: 113,
    Name: "Kevin O'Connor",
    Email: "kevin.oconnor@company.com",
    JobTitle: "Project Manager",
    Department: "Project Management",
    Status: "Clicked",
    LastActivity: "2024-07-02T12:34:56Z",
  },
];

export const mockLinksOverview: LinkOverviewDetails[] = [
  {
    AccountId: 2,
    AccountName: "BSI",
    LinkId: 187,
    LinkTitle: "Link from same account",
    TotalPageVisits: 1200,
    TotalClicks: 350980,
    ClickThroughRate: 0.2917345,
    LastActivity: "2024-06-25T14:23:00Z",
  },
  {
    AccountId: 61161,
    AccountName: "Channel Partner",
    LinkId: 208,
    LinkTitle: "Link from other account",
    TotalPageVisits: 800,
    TotalClicks: 200,
    ClickThroughRate: 0.25,
    LastActivity: "2024-06-24T10:00:00Z",
  },
  {
    AccountId: 1,
    AccountName: "TechCorp Industries",
    LinkId: 3,
    LinkTitle: "Password Policy Update",
    TotalPageVisits: 200,
    TotalClicks: 100,
    ClickThroughRate: 0.5,
    LastActivity: "2024-06-20T09:00:00Z",
  },
  {
    AccountId: 3,
    AccountName: "Healthcare Systems Inc",
    LinkId: 4,
    LinkTitle: "Compliance Training Resources",
    TotalPageVisits: 650,
    TotalClicks: 130,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-22T16:30:00Z",
  },
  {
    AccountId: 1,
    AccountName: "TechCorp Industries",
    LinkId: 5,
    LinkTitle:
      "IT Support Portal IT Support Portal IT Support Portal IT Support Portal IT Support Portal IT Support Portal IT Support Portal IT Support Portal",
    TotalPageVisits: 300,
    TotalClicks: 90,
    ClickThroughRate: 0.3,
    LastActivity: "2024-06-23T11:15:00Z",
  },
  {
    AccountId: 4,
    AccountName: "Educational Services",
    LinkId: 6,
    LinkTitle: "Employee Handbook",
    TotalPageVisits: 400,
    TotalClicks: 80,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-21T08:45:00Z",
  },
  {
    AccountId: 1,
    AccountName: "TechCorp Industries",
    LinkId: 7,
    LinkTitle: "Benefits Portal",
    TotalPageVisits: 950,
    TotalClicks: 285,
    ClickThroughRate: 0.3,
    LastActivity: "2024-06-26T13:20:00Z",
  },
  {
    AccountId: 2,
    AccountName: "Global Manufacturing Ltd",
    LinkId: 8,
    LinkTitle: "Customer Support Knowledge Base",
    TotalPageVisits: 720,
    TotalClicks: 144,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-24T09:30:00Z",
  },
  {
    AccountId: 5,
    AccountName: "Financial Services Corp",
    LinkId: 9,
    LinkTitle: "Company News and Updates",
    TotalPageVisits: 1100,
    TotalClicks: 330,
    ClickThroughRate: 0.3,
    LastActivity: "2024-06-26T16:45:00Z",
  },
  {
    AccountId: 3,
    AccountName: "Healthcare Systems Inc",
    LinkId: 10,
    LinkTitle: "Training Resources Library",
    TotalPageVisits: 850,
    TotalClicks: 170,
    ClickThroughRate: 0.2,
    LastActivity: "2021-06-25T11:20:00Z",
  },
  {
    AccountId: 1,
    AccountName: "TechCorp Industries",
    LinkId: 11,
    LinkTitle: "Software Download Center",
    TotalPageVisits: 600,
    TotalClicks: 240,
    ClickThroughRate: 0.4,
    LastActivity: "2024-06-23T14:15:00Z",
  },
  {
    AccountId: 6,
    AccountName: "Retail Chain Enterprise",
    LinkId: 12,
    LinkTitle: "Health and Safety Guidelines",
    TotalPageVisits: 450,
    TotalClicks: 90,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-19T08:00:00Z",
  },
  {
    AccountId: 4,
    AccountName: "Educational Services",
    LinkId: 13,
    LinkTitle: "Performance Review Portal",
    TotalPageVisits: 320,
    TotalClicks: 64,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-18T15:30:00Z",
  },
  {
    AccountId: 1,
    AccountName: "TechCorp Industries",
    LinkId: 14,
    LinkTitle: "Team Collaboration Tools",
    TotalPageVisits: 780,
    TotalClicks: 234,
    ClickThroughRate: 0.3,
    LastActivity: "2024-06-26T12:00:00Z",
  },
  {
    AccountId: 2,
    AccountName: "Global Manufacturing Ltd",
    LinkId: 15,
    LinkTitle: "Remote Work Resources",
    TotalPageVisits: 580,
    TotalClicks: 116,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-22T10:45:00Z",
  },
];

export const mockMessageLineCounts: MessageLineChart[] = [
  {
    Date: "2024-06-20",
    Sends: 120,
    Clicks: 36,
    CumulativeSends: 120,
    CumulativeClicks: 36,
  },
  {
    Date: "2024-06-21",
    Sends: 180,
    Clicks: 50,
    CumulativeSends: 300,
    CumulativeClicks: 86,
  },
  {
    Date: "2024-06-22",
    Sends: 90,
    Clicks: 30,
    CumulativeSends: 390,
    CumulativeClicks: 116,
  },
];

export const mockMessageEngagementCounts: MessageEngagement = {
  Accounts: 42,
  AverageSendSize: 85,
  ClickThroughRate: 0.27,
  Messages: 18,
  MessagesClicked: 110,
  MessagesSent: 410,
};

export const mockMessagesOverview: MessageOverviewDetails[] = [
  {
    MessageId: 501,
    MessageName: "Security Awareness Reminder",
    Sends: 1800,
    Clicks: 486,
    ClickThroughRate: 0.27,
    LastActivity: "2024-06-24T10:00:00Z",
  },
  {
    MessageId: 502,
    MessageName: "Quarterly Compliance Update",
    Sends: 1250,
    Clicks: 250,
    ClickThroughRate: 0.2,
    LastActivity: "2024-06-23T15:30:00Z",
  },
  {
    MessageId: 503,
    MessageName: "Executive Newsletter",
    Sends: 900,
    Clicks: 405,
    ClickThroughRate: 0.45,
    LastActivity: "2024-06-22T08:45:00Z",
  },
];

/**
 * End Phishing Campaign mock data
 */
